import { CreditCard } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const CreditCardIcon = DeckardIconWrapper({ Icon: CreditCard });
